export default __webpack_public_path__ + "static/media/profile.f2ed18f1.jfif";